var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75173 6.44725V10.2922C1.75173 10.6459 2.02113 10.933 2.35173 10.933H5.35173V6.44725H1.75173Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1517 3.88396H8.25333C8.38953 3.78463 8.50653 3.68595 8.58813 3.59751C9.07233 3.07781 9.07233 2.23192 8.58813 1.71221C8.11773 1.20596 7.29813 1.20725 6.82833 1.71221C6.56793 1.99097 5.87793 3.12587 5.97333 3.88396H5.93013C6.02493 3.12587 5.33493 1.99097 5.07513 1.71221C4.60473 1.20725 3.78513 1.20725 3.31533 1.71221C2.83173 2.23192 2.83173 3.07781 3.31473 3.59751C3.39693 3.68595 3.51393 3.78463 3.65013 3.88396H1.75173C1.42113 3.88396 1.15173 4.17169 1.15173 4.52478V5.48602C1.15173 5.66288 1.28613 5.80643 1.45173 5.80643H5.35173V4.52478H6.55173V5.80643H10.4517C10.6173 5.80643 10.7517 5.66288 10.7517 5.48602V4.52478C10.7517 4.17169 10.4829 3.88396 10.1517 3.88396ZM5.31633 3.86281C5.31633 3.86281 5.29113 3.88396 5.20533 3.88396C4.79073 3.88396 3.99933 3.42385 3.74073 3.14573C3.48933 2.87531 3.48933 2.43442 3.74073 2.16399C3.86253 2.03327 4.02393 1.96149 4.19553 1.96149C4.36653 1.96149 4.52793 2.03327 4.64973 2.16399C5.05413 2.59847 5.45613 3.70838 5.31633 3.86281ZM6.69753 3.88396C6.61233 3.88396 6.58713 3.86281 6.58713 3.86281C6.44733 3.70838 6.84933 2.59847 7.25373 2.16399C7.49553 1.90318 7.91853 1.9019 8.16273 2.16399C8.41473 2.43442 8.41473 2.87531 8.16273 3.14573C7.90413 3.42385 7.11273 3.88396 6.69753 3.88396Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55173 6.44725V10.933H9.55173C9.88293 10.933 10.1517 10.6459 10.1517 10.2922V6.44725H6.55173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.a7e8686c84586ef12758cbb0a8a0b899.svg";
export { ForwardRef as ReactComponent };